export default __webpack_public_path__ + "static/media/V545_RoHS.8cde7081.pdf";